<template>
  <BaseModal
    name="companiesModal"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    :minHeight="680"
    height="auto"
    :resizable="true"
    :width="1400"
    classes="bg-transparent shadow-none"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="mx-auto" style="width: 1280px">
      <BaseLoader v-if="modalInfo.loading"></BaseLoader>
      <div class="bg-system-main-block">
        <div
          class="bg-system-secondary py-10 px-30 d-flex gap-30"
          v-if="dataForModal"
        >
          <div class="d-flex justify-content-between flex-grow-1 fsc-11" >
            <div class="d-flex align-items-center flex-grow-1" v-if="Object.keys(dataForHeader) && !modalInfo.loading">
              <span class="">{{ dataForHeader?.companies__name }}</span>
              &nbsp;
              <span class="fw-bold">({{ dataForHeader?.companies__id }})</span>
              &nbsp;
              <span class="">{{ dataLang['reg_company_21'] }}</span>
              &nbsp;
              <span class="fw-bold">{{ dataForHeader?.companies__balance.split('.').join(',') }}</span>
            </div>
          </div>
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('companiesModal')"
          ></button>
        </div>
        <div class="pb-10">
          <VueTabs v-model="activateTab" @tab-change="handleTabChange" class="vue-tabs-type-1">
            <VTab
              :title="dataLang['clients_register_text_10']"
              data-name="mainTab"
            >
              <div class="px-30">
                <MainTab
                  ref="mainTab"
                  v-if="listTabs.mainTab"
                  :modalInfo="modalInfo"
                ></MainTab>
              </div>
            </VTab>
            <VTab
              :title="dataLang['clients_register_text_11']"
              data-name="balanceTab"
            >
              <div class="px-30">
                <BalanceTab
                  ref="balanceTab"
                  v-if="listTabs.balanceTab"
                  :modalInfo="modalInfo"
                ></BalanceTab>
              </div>
            </VTab>
            <VTab title="Рейтинг" data-name="ratingCompanyTab">
              <div class="px-30">
                <RatingCompanyTab
                  ref="ratingCompanyTab"
                  v-if="listTabs.ratingCompanyTab"
                  :modalInfo="modalInfo"
                ></RatingCompanyTab>
              </div>
            </VTab>
            <VTab title="Баллы" data-name="pointsCompanyTab">
              <div class="px-30">
                <PointsCompanyTab
                  ref="pointsCompanyTab"
                  v-if="listTabs.pointsCompanyTab"
                  :modalInfo="modalInfo"
                ></PointsCompanyTab>
              </div>
            </VTab>
            <VTab title="Сертификаты" data-name="certificatesCompanyTab">
              <div class="px-30">
                <CertificatesCompanyTab
                  ref="certificatesCompanyTab"
                  v-if="listTabs.certificatesCompanyTab"
                  :modalInfo="modalInfo"
                ></CertificatesCompanyTab>
              </div>
            </VTab>
          </VueTabs>
          <div class="d-flex justify-content-end gap-35 px-30">
            <div class="d-flex gap-10">
              <div
                class="base-button base-button--action py-10 px-30 text-uppercase"
                @click="$modal.hide('companiesModal')"
              >
                <span class="fsc-14">{{
                  dataLang['orders_model_edit__btn_text5']
                }}</span>
              </div>
              <div
                class="base-button base-button--action py-10 px-30 text-uppercase"
                @click="sendData"
              >
                <span class="fsc-14">{{
                  dataLang['orders_model_edit__btn_text6']
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import GeneralService from '@/api/GeneralService'
import EventBus from '@/event-bus.js'
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'
import BalanceTab from './BalanceTab.vue'
import RatingCompanyTab from './RatingCompanyTab.vue'
import PointsCompanyTab from './PointsCompanyTab.vue'
import CertificatesCompanyTab from './CertificatesCompanyTab.vue'
import MainTab from './MainTab.vue'
export default {
  components: {
    VueTabs,
    VTab,
    MainTab,
    BalanceTab,
    RatingCompanyTab,
    PointsCompanyTab,
    CertificatesCompanyTab
  },
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      dataForHeader: {},
      newTab: null,
      oldTab: null,
      mainInfo: {},
      modalInfo: {
        modalOpened: false,
        id: null,
        loading: true,
        data: {}
      },
      listTabs: {
        mainTab: false,
        balanceTab: false,
        ratingCompanyTab: false,
        pointsCompanyTab: false,
        certificatesCompanyTab: false
      },
      activeCurrentTab: 'mainTab',
      activateTab: null
    }
  },
  methods: {
    sendData() {
      this.$refs[this.activeCurrentTab].sendData(
        this.assignedTabChange,
        '',
        '',
        '',
        true
      )
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      if (oldTab.title !== newTab.title) {
        this.listTabs[oldTab.$attrs['data-name']] = true
        this.activeCurrentTab = newTab.$attrs['data-name']
        this.$refs[oldTab.$attrs['data-name']].sendData(
          this.assignedTabChange,
          oldTab.title,
          oldTab,
          newTab
        )
      }
    },
    assignedTabChange(
      isForward,
      linkToTabHasName,
      oldTab,
      newTab,
      flagIsClose
    ) {
      if (newTab && oldTab) {
        if (isForward) {
          this.listTabs[newTab.$attrs['data-name']] = true
          this.listTabs[oldTab.$attrs['data-name']] = false
          this.modalInfo.loading = false
        } else {
          this.activateTab = linkToTabHasName
          this.listTabs[newTab.$attrs['data-name']] = false
          this.listTabs[oldTab.$attrs['data-name']] = true
          this.modalInfo.loading = false
        }
      } else {
        if (flagIsClose) {
          this.$modal.hide('companiesModal')
        }
      }
    },
    getInfo() {
      // this.modalInfo.loading = true
      GeneralService.get(`/super/companies/tab/info/${this.modalInfo.id}`)
        .then((data) => {
          this.dataForModal = data.data.data
          this.modalInfo.data = Object.assign({}, this.dataForModal)
          this.modalInfo.loading = false
        })
        .catch((e) => {})
    },
    beforeOpen(data) {
      this.modalInfo.modalOpened = true
      this.modalInfo.id = data.params?.id
      this.dataForHeader = data.params?.data
      this.listTabs.mainTab = true
      this.modalInfo.data = data.params?.data
      this.getInfo()
    },
    beforeClose() {
      this.updatedValues = {}
      this.dataForModal = {}

      this.mainInfo = {}
      this.modalInfo = {
        modalOpened: false,
        id: null,
        loading: true,
        data: {}
      }
      this.activeCurrentTab = 'mainTab'
      this.activateTab = null
      Object.keys(this.listTabs).forEach((el, index) => {
        this.listTabs[el] = false
      })
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element['label'] = element[Object.keys(element).pop()]
          element['key'] = key
          element['value'] = Object.keys(element)[0]
          element['selectName'] = keyDataFromFetch
        })
      }
      return data
    }
  },
  mounted() {

    EventBus.$on('finishLoad', () => {
      this.modalInfo.loading = false
    })
    EventBus.$on('closeModal', () => {
      this.$modal.hide('companiesModal')
    })
    EventBus.$on('updateMainModalComponent', () => {
      this.getInfo()
    })
  },
  created() {},
  computed: {
    ...mapState('translationModule', ['dataLang']),
    ...mapState('userSettingModule', ['userSetting'])
  }
}
</script>
